import { Box, IconButton, Typography } from "@mui/material";
import { getColor } from "../style/color/color";
import { ReactComponent as AddIcon } from "../assets/icon/addicon.svg";
import { String } from "../constants/Strings";
import { fonts } from "../style/fonts/fonts";
export const AddDependantText = ({ label, onClickHandle }) => (
  <Box
    sx={{
      mt: "24px",
      width: "100%",
      borderRadius: "10px",
      display: "flex",
      justifyContent: "space-between",
      p: 1,
      backgroundColor: getColor.ColorpalettePrimaryMidnight,
    }}
    // component={"button"}
    onClick={onClickHandle}
  >
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography
        sx={{
          color: getColor.PrimaryWhite,
          fontSize: 16,
          fontFamily: fonts.manrope,
          fontWeight: "700",
          ml: "30px",
        }}
        variant="subtitle1"
      >
        {String.ChildPlannig.includeDependant}
      </Typography>
      <Typography
        sx={{
          color: getColor.PrimaryWhite,
          fontSize: 16,
          fontFamily: fonts.manrope,
          fontWeight: "700",
          ml: "10px",
        }}
        variant="subtitle1"
      >
        {String.ChildPlannig.improveaccuracy}
      </Typography>
    </Box>
    <IconButton sx={{ mr: "30px" }}>
      <AddIcon />
    </IconButton>
  </Box>
);
